import { call, put, takeEvery, all } from 'redux-saga/effects'
import allAvaliableTypes from './allAvaliableTypes'
import * as allAvaliableActions from './allAvaliableActions'
import AllAvaliableLoads from '../../services/LoadsService/AllAvaliableLoads'
export function * getAll ({ payload }) {
  try {
    const { offset } = payload
    if (offset === 0) {
      yield put(allAvaliableActions.clearLoads())
    }
    const { data, results } = yield call(AllAvaliableLoads.getAll, payload)
    yield put(allAvaliableActions.getLoadSuccess({ data, results }))
  } catch (error) {
    yield put(allAvaliableActions.getLoadFailure(error.message))
  }
}

export function * markFavorite ({ payload }) {
  try {
    yield call(AllAvaliableLoads.markUnmark, payload)
    yield put(allAvaliableActions.markFavoriteSuccess(payload))
  } catch (error) {
    yield put(allAvaliableActions.markFavoriteFailure(error.message))
  }
}

export function * onGetAll () {
  yield takeEvery(allAvaliableTypes.GET_LOADS, getAll)
}

export function * onMarkFavorite () {
  yield takeEvery(allAvaliableTypes.MARK_FAVORITE, markFavorite)
}

export function * allLoadsSaga () {
  yield all([
    call(onGetAll),
    call(onMarkFavorite)
  ])
}
